import {useState} from 'react'
import {Flash} from '@primer/react'
import {AlertFillIcon, StopIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {PendingChecksBody} from './shared/PendingChecksBody'
import {decideChecksItem} from './shared/checks-item-decider'
import {useValidatedChecksData} from './use-validated-checks-data'
import {ApproveWorkflowsButton} from '@github-ui/mergebox/components/sections/checks/ApproveWorkflowsButton'
import {WorkflowApprovalSubtitle} from '@github-ui/mergebox/components/sections/checks/WorkflowApprovalSubtitle'
import {checksSectionHeading} from '@github-ui/mergebox/components/sections/checks/checks-section-header-text'
import styles from '../shared/ForYouItem.module.css'

// Renders when workflow runs are awaiting approval and the viewer can approve them.
// Opens by default and surfaces the action to approve the pending workflow runs.
export function ApprovableChecks() {
  const data = useValidatedChecksData()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const decision = decideChecksItem(data)
  if (!data || decision.kind !== 'approvable') {
    return null
  }

  const {mergeBoxPullRequest, checksSection} = data
  const {workflowApproval} = decision

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={AlertFillIcon} variant="warning" />}
      title={checksSectionHeading[checksSection.sectionStatus]}
      itemName="pending-checks"
      padding="none"
      defaultOpen
      description={
        <WorkflowApprovalSubtitle pendingWorkflowApprovalRollup={workflowApproval} className={styles.description} />
      }
      actionSlot={
        <ApproveWorkflowsButton
          headSha={mergeBoxPullRequest.headRefOid}
          onApprovalStart={() => setErrorMessage(null)}
          onError={setErrorMessage}
        />
      }
    >
      {errorMessage && (
        <Flash className="tmp-m-3" variant="danger">
          <StopIcon className="mr-2" />
          {errorMessage}
        </Flash>
      )}

      <PendingChecksBody
        data={data}
        emptyMessage="Workflow runs are awaiting approval. Check results will appear once the workflows begin running."
      />
    </ForYouItem>
  )
}
